import { Record } from 'immutable';

export const PasswordRulesState = Record({
  minimumLength: 8,
  oneLetterOneNumber: true,
  oneUpperOneLower: false,
  oneSpecialChar: false,
  err: null,
  isValid: false,
  isFetching: false
});

export const PortalSettings = Record({
  passwordRules: new PasswordRulesState()
});

export const settingsReducer = (state = new PortalSettings(), action) => {
  switch (action.type) {

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// src/common/settings/settings.reducer.js